import React, { useEffect, useState } from "react";
import { Animated } from "react-native";
import { BALL_SIZE } from "../../constants/size";
const IMAGE_COIN = require("../../assets/coin.png");

export const Coin = () => {
  const [spinValue, setSpinValue] = useState(new Animated.Value(0));

  const spin = spinValue.interpolate({
    inputRange: [0, 1],
    outputRange: ["0deg", "360deg"],
  });

  const spinAnim = Animated.timing(spinValue, {
    toValue: 1,
    duration: 100,
    useNativeDriver: true,
  });

  const [opacity, setOpacity] = useState(new Animated.Value(1));
  const fadeAnim = Animated.timing(opacity, {
    toValue: 0,
    duration: 100,
    useNativeDriver: true,
  });

  useEffect(() => {
    Animated.parallel([spinAnim, fadeAnim]).start();
  }, []);

  return (
    <Animated.Image
      source={IMAGE_COIN}
      resizeMode="stretch"
      style={{
        width: BALL_SIZE,
        height: BALL_SIZE,
        transform: [{ rotateY: spin }],
        // opacity: opacity,
      }}
    />
  );
};
